import AGlobalNotifications from './a-global-notifications.vue';

export default AGlobalNotifications;
